import React from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import grey from "@material-ui/core/colors/grey";
import Grid from "@material-ui/core/Grid";

const TestItemDetailProjectRow = ({ field, value }) => {
  return (
    <Grid item xs={12}>
      <Typography
        sttyle={{
          display: "flex",
          alignItems: "center"
        }}
        component="div"
      >
        <span style={{ color: grey["500"] }}>{field}</span>{" "}
        <strong>{value}</strong>
      </Typography>
    </Grid>
  );
};

TestItemDetailProjectRow.propTypes = {
  field: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired
};

export default TestItemDetailProjectRow;



// WEBPACK FOOTER //
// ./src/modules/test/TestItemDetailProjectRow.js